// extracted by mini-css-extract-plugin
module.exports = {"container":"board-card-wrapper-new_container__5uwl_"};